import React from 'react';
import { Navigate } from 'react-router-dom';

// Legacy route: /dashboard → /accounts. Kept for backward-compatible bookmarks.
export default function DashboardPage() {
  return <Navigate to="/accounts" replace />;
}